import {
    FILTER_PILL,
    LOADING_CONTAINER,
    NOTIFICATION_CONTAINER,
    TEXT_HEADER,
} from './constants';
import mountFilterPill from '../../components/FilterPill';
import {
    ACCORDION_BASE_CLASSNAME,
    createAccordion,
} from '@vfde-brix/ws10/accordion';
import mountLoadingSpinner from '../../components/LoadingSpinner';
import mountFeatureCard from '../../components/FeatureCard';
import { mountBasketButton } from '../../components/Button';
import getCustomerConfig from 'Helper/getCustomerConfig';
import mountTextHeader from '../../components/TextHeader';
import { getCategoriesFromUrl } from './helpers/getCategoriesFromUrl';
import { getAccessoriesFromStorage } from './helpers/getAccessoriesFromStorage';
import {
    createComponents,
    NO_PATTERN_BUSINESS_LOGIC,
} from '@vfde-brix/ws10/core';
import mountOverlay from '../../components/Overlay';
import mountNotification from '../../components/Notification';
import { useDispatch } from '../../store';
import { setInitialState } from './slice';

const mountConnectMoreAppContainer = () => {
    const dispatch = useDispatch();

    createComponents(`.${ACCORDION_BASE_CLASSNAME}`, createAccordion, NO_PATTERN_BUSINESS_LOGIC);
    mountLoadingSpinner(LOADING_CONTAINER);
    mountOverlay();
    mountFilterPill(FILTER_PILL);
    mountTextHeader(TEXT_HEADER);
    mountNotification(NOTIFICATION_CONTAINER);
    mountBasketButton();
    mountFeatureCard();

    dispatch(setInitialState({
        customerConfig: getCustomerConfig(),
        categories: getCategoriesFromUrl(),
        products: getAccessoriesFromStorage(),
    }));
};

export default mountConnectMoreAppContainer;
